import { render, staticRenderFns } from "./MyApp.vue?vue&type=template&id=bb9458a4&"
import script from "./MyApp.vue?vue&type=script&lang=ts&"
export * from "./MyApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports